export default __webpack_public_path__ + "static/media/record_player_arm.7ee64b5d.svg";